import { InputAdornment, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import MobileNumberValidator from "../../../services/validation/personal-and-contact-details-form/MobileNumberValidator"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"

const MAX_LENGTH_MOBILE = 8

function MobileNumberInputField(props: FormFieldProps<string>) {
    const { t } = useTranslation(`signup`)
    const { handleChange, errorText, defaultValue, isDisabled } = props
    const [helperText, setHelperText] = useState(`` + errorText)
    const [error, setError] = useState(false)

    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        validateField(event.target.value)
        handleChange(event.target.value)
    }

    const validateField = (value: string) => {
        const validationText = (new MobileNumberValidator()).validate(value)
        setHelperText(validationText ?? ``)
        setError(validationText !== undefined)
    }

    useEffect(() => {
        setError(errorText !== undefined)
        setHelperText(errorText ?? ``)
    }, [errorText])

    return (
        <TextField
            fullWidth
            id="mobile-number-input"
            label={t(`mobile_number`)}
            variant="outlined"
            margin="normal"
            value={defaultValue}
            error={error}
            helperText={t(helperText)}
            onChange={handleOnChange}
            onBlur={handleOnChange}
            InputProps={{
                startAdornment: <InputAdornment position="start">+65</InputAdornment>,
            }}
            disabled={isDisabled}
            inputProps={{ inputMode: `numeric`, pattern: `[0-9]*`, maxLength: MAX_LENGTH_MOBILE }}
        />
    )
}

export default MobileNumberInputField